import React, { useState } from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import useAppContext from 'flow/hooks/useAppContext';
import { useHistory, useParams } from 'react-router-dom';
import {
    getCtiSetting,
    setCtiSetting,
    CTI_SETTINGS_OPEN_ON_ANSWER,
    CTI_SETTINGS_LABEL,
} from 'flow/utils/cti-settings-utils';
import { getCtiHost } from 'flow/utils/cti-config-utils';
import { addCtiLogEntry } from 'flow/utils/browser-utils';
import { ExtensionKey } from 'flow/types/EntityKeys';

import { routes } from 'flow/types/routes';
import Page from 'flow/components/Setting/Page';
import RadioButton from 'flow/components/ui-components/RadioButton';
import Divider from 'flow/components/ui-components/Divider';
import { CTI_LIST_SETTINGS_VALUE_LABELS } from 'flow/types/CTISettings';
import { generatePath } from 'flow/utils/router-utils';

const OpenOnAnswer = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const settings = useAppSelector(getCtiSetting);

    const [selectedOption, setSelectedOption] = useState(
        settings.openOnAnswer.value,
    );

    const updateSetting = (uniqueId: string) => {
        setSelectedOption(uniqueId);
        addCtiLogEntry(`setting openOnAnswer was changed to ${uniqueId}`);
        setCtiSetting({ ...settings, openOnAnswer: { value: uniqueId } });
    };

    const getOption = (option: string, translation: string) => (
        <RadioButton
            checked={selectedOption === option}
            name={option}
            onChange={() => updateSetting(option)}
        >
            {i18next.t(translation)}
        </RadioButton>
    );

    return (
        <Page
            header={i18next.t(CTI_SETTINGS_LABEL.openOnAnswer)}
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.cti-settings'], {
                        extensionKey,
                    }),
                )
            }
        >
            {getOption(
                CTI_SETTINGS_OPEN_ON_ANSWER.OFF,
                CTI_LIST_SETTINGS_VALUE_LABELS.openOnAnswer.off,
            )}

            {getCtiHost() !== 'hubspot'
                ? getOption(
                      CTI_SETTINGS_OPEN_ON_ANSWER.OPEN_TICKET,
                      CTI_LIST_SETTINGS_VALUE_LABELS.openOnAnswer.open_ticket,
                  )
                : null}

            <Divider />
        </Page>
    );
};

export default OpenOnAnswer;
